define('OutSystems/ClientRuntime/ClientInfo',["require", "exports", "./StorageProvider"], function (require, exports, StorageProvider_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.getClientInfo = exports.setClientInfo = void 0;
    var ClientInfo = (function () {
        function ClientInfo(_device) {
            this._device = _device;
        }
        Object.defineProperty(ClientInfo.prototype, "device", {
            get: function () {
                return this._device;
            },
            enumerable: false,
            configurable: true
        });
        return ClientInfo;
    }());
    var DeviceInfo = (function () {
        function DeviceInfo(_platform, _version, _manufacturer, _model, _uuid, _serial, _cordova, _isVirtual) {
            this._platform = _platform;
            this._version = _version;
            this._manufacturer = _manufacturer;
            this._model = _model;
            this._uuid = _uuid;
            this._serial = _serial;
            this._cordova = _cordova;
            this._isVirtual = _isVirtual;
        }
        Object.defineProperty(DeviceInfo.prototype, "platform", {
            get: function () {
                return this._platform;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DeviceInfo.prototype, "version", {
            get: function () {
                return this._version;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DeviceInfo.prototype, "manufacturer", {
            get: function () {
                return this._manufacturer;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DeviceInfo.prototype, "model", {
            get: function () {
                return this._model;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DeviceInfo.prototype, "uuid", {
            get: function () {
                return this._uuid;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DeviceInfo.prototype, "serial", {
            get: function () {
                return this._serial;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DeviceInfo.prototype, "cordova", {
            get: function () {
                return this._cordova;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DeviceInfo.prototype, "isVirtual", {
            get: function () {
                return this._isVirtual;
            },
            enumerable: false,
            configurable: true
        });
        return DeviceInfo;
    }());
    var Serialization;
    (function (Serialization) {
        function serializeClientInfo(clientInfo) {
            var obj = clientInfoToObject(clientInfo);
            if (!obj) {
                return;
            }
            return JSON.stringify(obj);
        }
        Serialization.serializeClientInfo = serializeClientInfo;
        function clientInfoToObject(clientInfo) {
            if (!clientInfo) {
                return;
            }
            return {
                device: clientInfo.device ? deviceInfoToObject(clientInfo.device) : undefined,
            };
        }
        function deviceInfoToObject(deviceInfo) {
            if (!deviceInfo) {
                return;
            }
            return {
                platform: deviceInfo.platform,
                version: deviceInfo.version,
                manufacturer: deviceInfo.manufacturer,
                model: deviceInfo.model,
                uuid: deviceInfo.uuid,
                serial: deviceInfo.serial,
                cordova: deviceInfo.cordova,
                isVirtual: deviceInfo.isVirtual,
            };
        }
        function deserializeClientInfo(json) {
            var obj;
            try {
                obj = JSON.parse(json);
            }
            catch (e) { }
            if (!obj) {
                return;
            }
            return objectToClientInfo(obj);
        }
        Serialization.deserializeClientInfo = deserializeClientInfo;
        function objectToClientInfo(source) {
            if (!source) {
                return;
            }
            return new ClientInfo(objectToDeviceInfo(source.device));
        }
        function objectToDeviceInfo(source) {
            if (!source) {
                return;
            }
            return new DeviceInfo(typeof source.platform === "string" ? source.platform : undefined, typeof source.version === "string" ? source.version : undefined, typeof source.manufacturer === "string" ? source.manufacturer : undefined, typeof source.model === "string" ? source.model : undefined, typeof source.uuid === "string" ? source.uuid : undefined, typeof source.serial === "string" ? source.serial : undefined, typeof source.cordova === "string" ? source.cordova : undefined, typeof source.isVirtual === "boolean" ? source.isVirtual : undefined);
        }
    })(Serialization || (Serialization = {}));
    var clientInfoStorage = new StorageProvider_1.StorageObject(StorageProvider_1.StorageType.Persistent, "ClientInfo");
    function setClientInfo() {
        var device = window.device;
        if (device) {
            var clientInfo = new ClientInfo(new DeviceInfo(device.platform, device.version, device.manufacturer, device.model, device.uuid, device.serial, device.cordova, device.isVirtual));
            clientInfoStorage.set(Serialization.serializeClientInfo(clientInfo));
        }
    }
    exports.setClientInfo = setClientInfo;
    function getClientInfo() {
        var clientInfoData = clientInfoStorage.get();
        if (!clientInfoData) {
            return;
        }
        return Serialization.deserializeClientInfo(clientInfoData);
    }
    exports.getClientInfo = getClientInfo;
});
//# sourceMappingURL=ClientInfo.js.map;
